export async function logOut() {
  const url = '/umbraco/api/member/member/logout'

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const text = await response.text()
    return text ? JSON.parse(text) : {}
  } catch (error) {
    console.error('Error logging out:', error)
    throw error
  }
}
